/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  'use strict';

  if (typeof window !== 'undefined' && window.bodyScrollLock && typeof window.bodyScrollLock.disableBodyScroll === 'function') {
    var originalDisableBodyScroll = window.bodyScrollLock.disableBodyScroll;

    window.bodyScrollLock.disableBodyScroll = function(targetElement, options) {
      var mergedOptions = options ? Object.assign({}, options) : {};
      var originalAllowTouchMove = mergedOptions.allowTouchMove;

      var shouldAllow = function(node) {
        var current = node;

        while (current) {
          if (current.nodeType === 3) {
            current = current.parentElement;
            continue;
          }

          if (current instanceof HTMLElement || current instanceof SVGElement) {
            if (current.tagName === 'TEXTAREA') {
              return true;
            }

            if (current.hasAttribute && current.hasAttribute('data-scroll-lock-allow')) {
              return true;
            }
          }

          current = current.parentElement;
        }

        return false;
      };

      mergedOptions.allowTouchMove = function(el) {
        if (shouldAllow(el)) {
          return true;
        }

        if (typeof originalAllowTouchMove === 'function') {
          try {
            if (originalAllowTouchMove(el)) {
              return true;
            }
          } catch (err) {
            /* ignore errors from original callback */
          }
        }

        return false;
      };

      return originalDisableBodyScroll.call(window.bodyScrollLock, targetElement, mergedOptions);
    };
  }

  var SELECTORS = {
    productGrid: '[data-product-grid-item]',
    holder: '[data-quick-add-holder]',
    label: '[data-quick-add-label]',
    formHolder: '[data-quick-add-form-holder]',
    form: '[data-form-quick-add]',
    selectOption: '[data-select-option]',
    optionInput: '[data-single-option-selector]',
    backButton: '[data-back-button]',
    popout: '[data-popout]',
    popoutToggle: '[data-popout-toggle]',
    popoutList: '[data-popout-list]',
    popoutOption: '[data-popout-option]',
    popoutInput: '[data-popout-input]',
    quickAddButtonAttr: 'data-quick-add-button',
    goToNextAttr: 'data-go-to-next',
    messageError: '[data-message-error]',
    idInput: '[name="id"]',
    mobileTrigger: '[data-button-quick-add-mobile]',
    section: '[data-section-id]',
    productJson: '[data-product-json]',
    productOptionsJson: '[data-product-options-json]',
    scrollbar: '[data-scrollbar]',
    scrollbarArrowPrev: '[data-scrollbar-arrow-prev]',
    scrollbarArrowNext: '[data-scrollbar-arrow-next]',
    scrollbarSlideFullWidthAttr: 'data-scrollbar-slide-fullwidth'
  };

  var CLASSES = {
    active: 'is-active',
    selected: 'is-selected',
    hide: 'is-hidden',
    visible: 'is-visible',
    loading: 'is-loading',
    added: 'is-added',
    error: 'has-error'
  };

  var POPUP_VISIBLE = 'popout-list--visible';
  var instances = [];
  var activePopout = null;

  function QuickAddScrollbar(scrollbar, arrowPrev, arrowNext) {
    if (!scrollbar || !arrowPrev || !arrowNext) {
      return;
    }

    this.scrollbar = scrollbar;
    this.arrowPrev = arrowPrev;
    this.arrowNext = arrowNext;

    this.handleScroll = this.update.bind(this);
    this.handleResize = this.update.bind(this);
    this.handleNextClick = this.goToNext.bind(this);
    this.handlePrevClick = this.goToPrev.bind(this);

    this.update();
    this.bindEvents();

    var _this = this;
    if (typeof window.requestAnimationFrame === 'function') {
      window.requestAnimationFrame(function() {
        _this.update();
      });
    }
  }

  QuickAddScrollbar.prototype.bindEvents = function() {
    this.arrowNext.addEventListener('click', this.handleNextClick);
    this.arrowPrev.addEventListener('click', this.handlePrevClick);
    this.scrollbar.addEventListener('scroll', this.handleScroll);
    document.addEventListener('theme:resize', this.handleResize);
    window.addEventListener('resize', this.handleResize);
  };

  QuickAddScrollbar.prototype.update = function() {
    if (!this.scrollbar || !this.arrowPrev || !this.arrowNext) {
      return;
    }

    var rect = this.scrollbar.getBoundingClientRect();
    var width = rect.width;
    var scrollWidth = this.scrollbar.scrollWidth;

    if (!width || Math.round(width + 1) >= Math.round(scrollWidth)) {
      this.arrowPrev.classList.add(CLASSES.hide);
      this.arrowNext.classList.add(CLASSES.hide);
      return;
    }

    var scrollLeft = this.scrollbar.scrollLeft;
    var maxScrollLeft = scrollWidth - width;

    if (scrollLeft <= 0) {
      this.arrowPrev.classList.add(CLASSES.hide);
    } else {
      this.arrowPrev.classList.remove(CLASSES.hide);
    }

    if (Math.round(scrollLeft + width + 1) >= scrollWidth || maxScrollLeft <= 0) {
      this.arrowNext.classList.add(CLASSES.hide);
    } else {
      this.arrowNext.classList.remove(CLASSES.hide);
    }
  };

  QuickAddScrollbar.prototype.getStep = function() {
    if (!this.scrollbar) {
      return 0;
    }

    var stepMode = this.scrollbar.getAttribute('data-scrollbar-step');
    if (stepMode === 'item') {
      var item = this.scrollbar.querySelector('[data-radio-option], [data-select-option] > *');
      if (!item) {
        item = this.scrollbar.firstElementChild;
      }
      if (item) {
        var itemRect = item.getBoundingClientRect();
        var itemWidth = itemRect.width;
        var computedStyle = window.getComputedStyle(item);
        var marginLeft = parseFloat(computedStyle.marginLeft || 0);
        var marginRight = parseFloat(computedStyle.marginRight || 0);
        var totalWidth = itemWidth + marginLeft + marginRight;

        if (totalWidth > 0) {
          return totalWidth;
        }
      }
    }

    var rect = this.scrollbar.getBoundingClientRect();
    var width = rect.width;

    if (!width) {
      return 0;
    }

    if (this.scrollbar.hasAttribute(SELECTORS.scrollbarSlideFullWidthAttr)) {
      return width;
    }

    return width / 2;
  };

  QuickAddScrollbar.prototype.scrollTo = function(left) {
    var max = Math.max(0, this.scrollbar.scrollWidth - this.scrollbar.clientWidth);
    var target = Math.max(0, Math.min(left, max));

    this.scrollbar.scrollTo({
      top: 0,
      left: target,
      behavior: 'smooth'
    });

    if (typeof window.requestAnimationFrame === 'function') {
      var _this = this;
      window.requestAnimationFrame(function() {
        _this.update();
      });
    } else {
      this.update();
    }
  };

  QuickAddScrollbar.prototype.goToNext = function(event) {
    if (event) {
      event.preventDefault();
    }

    var step = this.getStep();
    if (!step) {
      return;
    }

    this.scrollTo(this.scrollbar.scrollLeft + step);
  };

  QuickAddScrollbar.prototype.goToPrev = function(event) {
    if (event) {
      event.preventDefault();
    }

    var step = this.getStep();
    if (!step) {
      return;
    }

    this.scrollTo(this.scrollbar.scrollLeft - step);
  };

  function normaliseRoot(root) {
    if (!root) {
      return '/';
    }

    if (root === '/') {
      return '';
    }

    return root.replace(/\/$/, '');
  }

  function getStrings() {
    return (window.theme && window.theme.strings) || {};
  }

  function dispatchAddToCart(detail) {
    var event = new CustomEvent('cart:add-to-cart', {
      bubbles: true,
      detail: detail
    });

    document.documentElement.dispatchEvent(event);
  }

  function QuickAdd(grid) {
    if (!grid || grid.__customQuickAddInitialized) {
      return;
    }

    this.grid = grid;
    this.holder = grid.querySelector(SELECTORS.holder);

    if (!this.holder) {
      return;
    }

    this.label = this.holder.querySelector(SELECTORS.label);
    this.formHolder = this.holder.querySelector(SELECTORS.formHolder);
    this.mobileTrigger = grid.querySelector(SELECTORS.mobileTrigger);

    if (!this.label && !this.mobileTrigger) {
      return;
    }

    grid.__customQuickAddInitialized = true;

    this.errorMessage = this.holder.querySelector(SELECTORS.messageError);
    this.section = this.holder.closest(SELECTORS.section);

    this.productHandle = this.label && this.label.getAttribute('data-quick-add-label');
    this.collectionHandle = this.label && this.label.getAttribute('data-collection-handle');
    this.sectionId = this.section && this.section.getAttribute('data-section-id');

    this.formPromise = null;
    this.formInitialised = false;
    this.productJSON = null;
    this.productForm = null;
    this.selectOptions = [];
    this.optionInputs = [];
    this.idInput = null;
    this.currentVariant = null;

    this.outsideClickHandler = null;

    this.init();
  }

  QuickAdd.prototype.init = function() {
    instances.push(this);

    var preload = this.preloadForm.bind(this);

    if (this.grid) {
      this.grid.addEventListener('mouseenter', preload, { once: true });
    }

    if (this.label) {
      this.label.addEventListener('click', this.handleLabelClick.bind(this));
      this.label.addEventListener('keydown', this.handleLabelKeydown.bind(this));
      this.label.addEventListener('focusin', preload, { once: true });
    }

    if (this.mobileTrigger) {
      this.mobileTrigger.addEventListener('click', this.handleMobileClick.bind(this));
    }

    document.documentElement.addEventListener('theme:cart-close', this.resetState.bind(this));
  };

  QuickAdd.prototype.preloadForm = function() {
    if (!this.productHandle || this.formInitialised || this.formPromise) {
      return;
    }

    this.fetchForm(function() {});
  };

  QuickAdd.prototype.handleLabelClick = function(event) {
    event.preventDefault();

    if (this.label && this.label.classList.contains(CLASSES.loading)) {
      return;
    }

    this.open('label');
  };

  QuickAdd.prototype.handleLabelKeydown = function(event) {
    if (!this.label) {
      return;
    }

    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.open('label');
    }
  };

  QuickAdd.prototype.handleMobileClick = function(event) {
    event.preventDefault();

    if (this.mobileTrigger && this.mobileTrigger.classList.contains(CLASSES.loading)) {
      return;
    }

    this.open('mobile');
  };

  QuickAdd.prototype.open = function(source) {
    var _this = this;
    var trigger = source === 'mobile' ? this.mobileTrigger : this.label;

    this.setLoading(true, trigger);

    this.fetchForm(function(success) {
      if (!success || !_this.productJSON) {
        _this.setLoading(false, trigger);
        return;
      }

      if (_this.shouldAutoAdd()) {
        _this.addDefaultVariant(trigger);
        return;
      }

      _this.setLoading(false, trigger);
      _this.showHolder(source);
    });
  };

  QuickAdd.prototype.fetchForm = function(callback) {
    var _this = this;

    if (this.formInitialised) {
      callback(true);
      return;
    }

    if (this.formPromise) {
      this.formPromise.then(function() {
        callback(Boolean(_this.productJSON));
      });
      return;
    }

    if (!this.productHandle || !this.formHolder) {
      callback(false);
      return;
    }

    var root = normaliseRoot(window.theme && window.theme.routes && window.theme.routes.root);
    var url = root + '/products/' + this.productHandle + '?section_id=api-quick-add';

    this.formPromise = fetch(url, { credentials: 'same-origin' })
      .then(function(response) {
        if (!response.ok) {
          throw new Error('Quick add request failed');
        }

        return response.text();
      })
      .then(function(html) {
        var container = document.createElement('div');
        container.innerHTML = html;

        var content = container.querySelector('[data-api-content]');
        if (!content) {
          throw new Error('Quick add markup missing');
        }

        var collectionKey = (_this.collectionHandle || 'primary') + '-' + (_this.sectionId || 'main');
        var markup = content.innerHTML.replace(/\|\|collection-index\|\|/g, collectionKey);

        _this.formHolder.innerHTML = markup;
        _this.initialiseForm();
        _this.formInitialised = true;
        callback(Boolean(_this.productJSON));
      })
      .catch(function(error) {
        console.warn(error);
        _this.showError(getStrings().unavailable || 'Unavailable');
        callback(false);
      });
  };

  QuickAdd.prototype.initialiseForm = function() {
    this.form = this.formHolder.querySelector(SELECTORS.form);
    if (!this.form) {
      return;
    }

    this.refreshOptionCaches();
    var _this = this;
    this.scrollbars = Array.prototype.slice.call(this.formHolder.querySelectorAll(SELECTORS.scrollbar)).map(function(scrollbar) {
      var container = scrollbar.parentElement || _this.formHolder;

      return {
        scrollbar: scrollbar,
        arrowPrev: container.querySelector(SELECTORS.scrollbarArrowPrev),
        arrowNext: container.querySelector(SELECTORS.scrollbarArrowNext)
      };
    });

    this.scrollbarHelpers = this.scrollbars
      .map(function(group) {
        if (!group.scrollbar || !group.arrowPrev || !group.arrowNext) {
          return null;
        }

        return new QuickAddScrollbar(group.scrollbar, group.arrowPrev, group.arrowNext);
      })
      .filter(Boolean);

    this.selectOptions = Array.prototype.slice.call(this.formHolder.querySelectorAll(SELECTORS.selectOption));
    this.optionInputs = Array.prototype.slice.call(this.formHolder.querySelectorAll(SELECTORS.optionInput));
    this.idInput = this.form.querySelector(SELECTORS.idInput);

    var productJsonElement = this.formHolder.querySelector(SELECTORS.productJson);

    try {
      this.productJSON = productJsonElement ? JSON.parse(productJsonElement.textContent.trim()) : null;
    } catch (error) {
      console.warn('Failed to parse product data', error);
      this.productJSON = null;
    }

    if (typeof window.ProductForm === 'function' && this.productJSON) {
      this.productForm = new window.ProductForm(this.form, this.productJSON, {
        onOptionChange: this.onProductFormChange.bind(this)
      });
    } else {
      this.form.addEventListener('change', this.onFallbackChange.bind(this));
    }

    this.bindBackButtons();
    this.bindPopouts();
    this.form.addEventListener('submit', this.handleSubmit.bind(this));
  };

  QuickAdd.prototype.onProductFormChange = function(event) {
    this.handleOptionChange(event.target, event.dataset);
  };

  QuickAdd.prototype.onFallbackChange = function(event) {
    var target = event.target;
    if (!target || !target.matches(SELECTORS.optionInput)) {
      return;
    }

    var dataset = this.buildFallbackDataset();
    this.handleOptionChange(target, dataset);
  };

  QuickAdd.prototype.buildFallbackDataset = function() {
    var options = [];

    this.optionInputs.forEach(function(input) {
      if (input.type === 'radio' || input.type === 'checkbox') {
        if (input.checked) {
          options.push({ name: input.name, value: input.value });
        }
      } else if (input.value) {
        options.push({ name: input.name, value: input.value });
      }
    });

    return {
      options: options,
      variant: this.findVariantFromOptions(options)
    };
  };

  QuickAdd.prototype.refreshOptionCaches = function() {
    if (!this.formHolder) {
      this.selectOptions = [];
      this.optionInputs = [];
      return;
    }

    this.selectOptions = Array.prototype.slice.call(this.formHolder.querySelectorAll(SELECTORS.selectOption));
    this.optionInputs = Array.prototype.slice.call(this.formHolder.querySelectorAll(SELECTORS.optionInput));
  };

  QuickAdd.prototype.bindBackButtons = function() {
    var _this = this;

    var backButtons = this.formHolder.querySelectorAll(SELECTORS.backButton);
    backButtons.forEach(function(button) {
      button.addEventListener('click', function(event) {
        event.preventDefault();
        _this.refreshOptionCaches();

        var currentStep = button.closest(SELECTORS.selectOption);
        if (!currentStep) {
          return;
        }

        var index = _this.selectOptions.indexOf(currentStep);
        if (index === -1) {
          return;
        }

        QuickAdd.closeAllPopouts();

        _this.clearStepSelection(currentStep);
        currentStep.classList.remove(CLASSES.active);

        var previousStep = _this.selectOptions[index - 1];

        if (previousStep) {
          previousStep.classList.add(CLASSES.active);
          _this.focusStep(previousStep);
        } else {
          _this.resetState();

          if (_this.mobileTrigger) {
            _this.mobileTrigger.classList.remove(CLASSES.hide);
            if (typeof _this.mobileTrigger.focus === 'function') {
              _this.mobileTrigger.focus();
            }
          } else if (_this.label && typeof _this.label.focus === 'function') {
            _this.label.focus();
          }
        }

        _this.syncVariantFromInputs();
      });
    });
  };

  QuickAdd.prototype.clearStepSelection = function(step) {
    if (!step) {
      return;
    }

    step.classList.remove(CLASSES.selected);

    var optionInputs = step.querySelectorAll(SELECTORS.optionInput);
    optionInputs.forEach(function(input) {
      if (input.type === 'radio' || input.type === 'checkbox') {
        input.checked = false;
        input.removeAttribute('checked');
      } else {
        input.value = '';
        input.setAttribute('value', '');
      }
    });

    var popout = step.querySelector(SELECTORS.popout);
    if (popout) {
      var toggle = popout.querySelector(SELECTORS.popoutToggle);
      var list = popout.querySelector(SELECTORS.popoutList);

      if (list) {
        list.querySelectorAll('[aria-current="true"]').forEach(function(option) {
          option.removeAttribute('aria-current');

          if (option.parentElement) {
            option.parentElement.classList.remove('select-popout__item--current');
          }
        });
      }

      if (toggle) {
        var defaultText = toggle.getAttribute('data-default-text');
        if (defaultText) {
          toggle.textContent = defaultText;
        }
      }
    }
  };

  QuickAdd.prototype.focusStep = function(step) {
    if (!step) {
      return;
    }

    var focusTarget = null;
    var optionInputs = step.querySelectorAll(SELECTORS.optionInput);

    for (var i = 0; i < optionInputs.length; i += 1) {
      var input = optionInputs[i];
      if (input.type !== 'hidden' && !input.disabled) {
        focusTarget = input;
        break;
      }
    }

    if (!focusTarget) {
      focusTarget = step.querySelector(SELECTORS.popoutToggle);
    }

    if (!focusTarget) {
      focusTarget = step.querySelector('button:not([disabled]), [href], [tabindex]:not([tabindex="-1"])');
    }

    if (focusTarget && typeof focusTarget.focus === 'function') {
      focusTarget.focus();
    }
  };

  QuickAdd.prototype.syncVariantFromInputs = function() {
    var dataset = this.buildFallbackDataset();
    var variant = dataset && dataset.variant ? dataset.variant : null;

    this.currentVariant = variant;

    if (this.idInput) {
      var idValue = this.currentVariant ? this.currentVariant.id : '';
      this.idInput.value = idValue;
      this.idInput.setAttribute('value', idValue);
    }
  };

  QuickAdd.prototype.bindPopouts = function() {
    var popouts = this.formHolder.querySelectorAll(SELECTORS.popout);

    popouts.forEach(function(popout) {
      var toggle = popout.querySelector(SELECTORS.popoutToggle);
      var list = popout.querySelector(SELECTORS.popoutList);
      var input = popout.querySelector(SELECTORS.popoutInput);

      if (!toggle || !list || !input) {
        return;
      }

      if (!toggle.hasAttribute('data-default-text')) {
        toggle.setAttribute('data-default-text', toggle.textContent.trim());
      }

      var resetOptionState = function() {
        list.querySelectorAll('[aria-current="true"]').forEach(function(activeOption) {
          activeOption.removeAttribute('aria-current');

          if (activeOption.parentElement) {
            activeOption.parentElement.classList.remove('select-popout__item--current');
          }
        });

        var defaultText = toggle.getAttribute('data-default-text');
        if (defaultText) {
          toggle.textContent = defaultText;
        }
      };

      var applyOptionState = function(option) {
        resetOptionState();

        if (!option) {
          return;
        }

        option.setAttribute('aria-current', 'true');

        if (option.parentElement) {
          option.parentElement.classList.add('select-popout__item--current');
        }

        toggle.textContent = option.textContent.trim();
      };

      var closeList = function() {
        toggle.setAttribute('aria-expanded', 'false');
        list.classList.remove(POPUP_VISIBLE);
        if (activePopout && activePopout.close === closeList) {
          activePopout = null;
        }
      };

      toggle.addEventListener('click', function(event) {
        event.preventDefault();
        var expanded = toggle.getAttribute('aria-expanded') === 'true';

        if (expanded) {
          closeList();
        } else {
          QuickAdd.closeAllPopouts();
          toggle.setAttribute('aria-expanded', 'true');
          list.classList.add(POPUP_VISIBLE);
          activePopout = { close: closeList };
        }
      });

      list.querySelectorAll(SELECTORS.popoutOption).forEach(function(option) {
        option.addEventListener('click', function(event) {
          event.preventDefault();
          var value = option.getAttribute('data-value');

          if (typeof value === 'string') {
            input.value = value;
            input.setAttribute('value', value);
            input.dispatchEvent(new Event('change', { bubbles: true }));
            applyOptionState(option);
          }

          closeList();
        });
      });

      if (input.value) {
        var initialOption = null;
        list.querySelectorAll(SELECTORS.popoutOption).forEach(function(option) {
          if (!initialOption && option.getAttribute('data-value') === input.value) {
            initialOption = option;
          }
        });

        if (initialOption) {
          applyOptionState(initialOption);
        }
      }
    });
  };

  QuickAdd.closeAllPopouts = function() {
    if (activePopout && typeof activePopout.close === 'function') {
      activePopout.close();
    }

    activePopout = null;
  };

  QuickAdd.prototype.handleOptionChange = function(target, dataset) {
    if (!target) {
      return;
    }

    var variant = dataset && dataset.variant ? dataset.variant : null;
    if (!variant && dataset && dataset.options) {
      variant = this.findVariantFromOptions(dataset.options);
    }

    this.currentVariant = variant || null;

    if (this.idInput && this.currentVariant) {
      this.idInput.value = this.currentVariant.id;
    }

    this.clearError();

    var step = target.closest(SELECTORS.selectOption);
    if (step) {
      step.classList.add(CLASSES.selected);
      step.classList.remove(CLASSES.active);
      this.moveToNextStep(step);
    }

    if (target.hasAttribute(SELECTORS.quickAddButtonAttr)) {
      if (this.currentVariant && this.currentVariant.available) {
        this.submitVariant(this.currentVariant, this.label);
      } else if (this.currentVariant) {
        this.showError(getStrings().soldOut || 'Sold out');
      } else {
        this.showError(getStrings().unavailable || 'Unavailable');
      }
    }
  };

  QuickAdd.prototype.moveToNextStep = function(currentStep) {
    var index = this.selectOptions.indexOf(currentStep);
    if (index === -1) {
      return;
    }

    var next = this.selectOptions[index + 1];
    if (next) {
      next.classList.add(CLASSES.active);
    }
  };

  QuickAdd.prototype.handleSubmit = function(event) {
    event.preventDefault();

    if (this.currentVariant && this.currentVariant.available) {
      this.submitVariant(this.currentVariant, this.label);
    } else {
      this.showError(getStrings().selectValue || 'Please select an option');
    }
  };

  QuickAdd.prototype.findVariantFromOptions = function(selectedOptions) {
    if (!this.productJSON || !Array.isArray(selectedOptions)) {
      return null;
    }

    var optionValues = selectedOptions.map(function(option) {
      return option.value;
    });

    for (var i = 0; i < this.productJSON.variants.length; i += 1) {
      var variant = this.productJSON.variants[i];
      if (!variant.options) {
        continue;
      }

      var matches = variant.options.every(function(value, index) {
        return optionValues[index] === value;
      });

      if (matches) {
        return variant;
      }
    }

    return null;
  };

  QuickAdd.prototype.showHolder = function(source) {
    QuickAdd.closeOthers(this);

    this.activateFirstStep();
    this.clearError();

    this.holder.classList.add(CLASSES.visible);

    if (Array.isArray(this.scrollbarHelpers) && this.scrollbarHelpers.length) {
      this.scrollbarHelpers.forEach(function(helper) {
        if (!helper || typeof helper.update !== 'function') {
          return;
        }

        helper.update();

        if (typeof window.requestAnimationFrame === 'function') {
          window.requestAnimationFrame(function() {
            helper.update();
          });
        }
      });
    }

    if (source === 'label' && this.label) {
      this.label.classList.add(CLASSES.hide);
    }

    if (source === 'mobile' && this.mobileTrigger) {
      this.mobileTrigger.classList.add(CLASSES.hide);
    }

    this.registerOutsideClick();
  };

  QuickAdd.prototype.hideHolder = function() {
    this.holder.classList.remove(CLASSES.visible);

    if (this.label) {
      this.label.classList.remove(CLASSES.hide);
      this.label.classList.remove(CLASSES.loading);
    }

    if (this.mobileTrigger) {
      this.mobileTrigger.classList.remove(CLASSES.hide);
      this.mobileTrigger.classList.remove(CLASSES.loading);
    }
  };

  QuickAdd.prototype.activateFirstStep = function() {
    this.selectOptions.forEach(function(step, index) {
      step.classList.remove(CLASSES.active);
      step.classList.remove(CLASSES.selected);

      if (index === 0) {
        step.classList.add(CLASSES.active);
      }
    });
  };

  QuickAdd.prototype.registerOutsideClick = function() {
    var _this = this;

    if (this.outsideClickHandler) {
      return;
    }

    this.outsideClickHandler = function(event) {
      var target = event.target;
      var insideHolder = _this.holder.contains(target);
      var insideLabel = _this.label && _this.label.contains(target);
      var insideMobile = _this.mobileTrigger && _this.mobileTrigger.contains(target);

      if (!insideHolder && !insideLabel && !insideMobile) {
        QuickAdd.closeAllPopouts();
        _this.resetState();
      }
    };

    document.addEventListener('click', this.outsideClickHandler);
  };

  QuickAdd.prototype.unregisterOutsideClick = function() {
    if (!this.outsideClickHandler) {
      return;
    }

    document.removeEventListener('click', this.outsideClickHandler);
    this.outsideClickHandler = null;
  };

  QuickAdd.prototype.resetState = function() {
    this.hideHolder();
    this.clearError();
    this.unregisterOutsideClick();
    this.activateFirstStep();
  };

  QuickAdd.prototype.setLoading = function(state, button) {
    var targets = [];

    if (button) {
      targets.push(button);
    } else {
      if (this.label) {
        targets.push(this.label);
      }
      if (this.mobileTrigger) {
        targets.push(this.mobileTrigger);
      }
    }

    targets.forEach(function(target) {
      target.classList.toggle(CLASSES.loading, Boolean(state));
    });
  };

  QuickAdd.prototype.submitVariant = function(variant, button) {
    if (!variant || !variant.id) {
      this.showError(getStrings().unavailable || 'Unavailable');
      this.setLoading(false, button);
      return;
    }

    this.setLoading(true, button);

    dispatchAddToCart({
      element: this.holder,
      label: button || this.label || this.mobileTrigger || this.holder,
      data: {
        id: variant.id,
        quantity: 1
      }
    });

    this.showSuccessState(button);
  };

  QuickAdd.prototype.showSuccessState = function(button) {
    var target = button || this.label || this.mobileTrigger;

    if (target) {
      target.classList.add(CLASSES.added);
      setTimeout(function() {
        target.classList.remove(CLASSES.added);
      }, 1200);
    }

    this.setLoading(false, target);
    this.resetState();
  };

  QuickAdd.prototype.showError = function(message) {
    if (this.errorMessage) {
      this.errorMessage.textContent = message;
    }

    if (this.label) {
      this.label.classList.add(CLASSES.error);
    }

    if (this.mobileTrigger) {
      this.mobileTrigger.classList.add(CLASSES.error);
    }
  };

  QuickAdd.prototype.clearError = function() {
    if (this.errorMessage) {
      this.errorMessage.innerHTML = '&nbsp;';
    }

    if (this.label) {
      this.label.classList.remove(CLASSES.error);
    }

    if (this.mobileTrigger) {
      this.mobileTrigger.classList.remove(CLASSES.error);
    }
  };

  QuickAdd.prototype.shouldAutoAdd = function() {
    if (!this.productJSON || !this.productJSON.variants || this.productJSON.variants.length !== 1) {
      return false;
    }

    var hasAutoButton = (this.label && this.label.hasAttribute(SELECTORS.quickAddButtonAttr)) ||
      (this.mobileTrigger && this.mobileTrigger.hasAttribute(SELECTORS.quickAddButtonAttr));

    return hasAutoButton;
  };

  QuickAdd.prototype.addDefaultVariant = function(button) {
    if (!this.productJSON || !this.productJSON.variants || !this.productJSON.variants.length) {
      this.setLoading(false, button);
      return;
    }

    var defaultVariant = this.productJSON.variants[0];

    if (!defaultVariant.available) {
      this.showError(getStrings().soldOut || 'Sold out');
      this.setLoading(false, button);
      return;
    }

    this.submitVariant(defaultVariant, button);
  };

  QuickAdd.closeOthers = function(instance) {
    instances.forEach(function(controller) {
      if (controller !== instance) {
        controller.resetState();
      }
    });
  };

  QuickAdd.pruneInstances = function() {
    for (var index = instances.length - 1; index >= 0; index--) {
      var instance = instances[index];

      if (!instance || !instance.grid || !document.body.contains(instance.grid)) {
        instances.splice(index, 1);
      }
    }
  };

  QuickAdd.initAll = function(root) {
    if (!window.theme || !window.theme.customQuickAddEnabled) {
      return;
    }

    QuickAdd.pruneInstances();

    var context = root && typeof root.querySelectorAll === 'function' ? root : document;
    var grids = context.querySelectorAll(SELECTORS.productGrid);
    grids.forEach(function(grid) {
      new QuickAdd(grid);
    });
  };

  if (!window.theme) {
    window.theme = {};
  }

  window.theme.customQuickAddInit = function(root) {
    QuickAdd.initAll(root);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      QuickAdd.initAll();
    });
  } else {
    QuickAdd.initAll();
  }

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
